// extracted by mini-css-extract-plugin
export default {"tosMain":"TermsOfServicePage_tosMain__oDBZd","tosNav":"TermsOfServicePage_tosNav__YrdCR","heading":"TermsOfServicePage_heading__4rqPb","content":"TermsOfServicePage_content__mW7Ht"};